import React from 'react'

export const CardIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style} className='icon--payment icon--payment-card'
    viewBox='0 0 32 32'
  >
    <path
      d='M28.4,6H3.6C2.3,6,1.4,7,1.4,8.1v15.7c0,1.2,1,2.1,2.1,2.1h24.9c1.2,0,2.1-1,2.1-2.1V8.1 C30.6,6.9,29.6,6,28.4,6z M3.4,6.8h24.9c0.7,0,1.3,0.6,1.3,1.3v0.7H2V8.1C2.2,7.4,2.7,6.8,3.4,6.8z M28.4,25.2H3.6 c-0.7,0-1.3-0.6-1.3-1.3V13h27.6v10.8C29.7,24.5,29.2,25.2,28.4,25.2z'
    />
    <path
      d='M27.3,19.3h-3.8c-0.2,0-0.4,0.2-0.4,0.4v2.9c0,0.2,0.2,0.4,0.4,0.4h3.8c0.2,0,0.4-0.2,0.4-0.4v-2.9 C27.7,19.5,27.6,19.3,27.3,19.3z M26.9,22.2h-3v-2.1h3V22.2z'
    />
  </svg>
)
